import Page from './page';
import GTMInit from './gtm-init';

export { Page, GTMInit };
